export default {
  "admin.faqTab.searchPlaceholder": "SSS öğelerinde ara...",
  "admin.faqTab.allCategories": "Tüm Kategoriler",
  "admin.faqTab.allStatuses": "Tüm Durumlar",
  "admin.faqTab.active": "Aktif",
  "admin.faqTab.inactive": "Pasif",
  "admin.faqTab.clear": "Temizle",
  "admin.faqTab.newFAQ": "Yeni SSS Ekle",
  "admin.faqTab.editFAQ": "SSS Düzenle",
  "admin.faqTab.saveChanges": "Değişiklikleri Kaydet",
  "admin.faqTab.createItem": "Öğe Oluştur",
  "admin.faqTab.cancel": "İptal",
  "admin.faqTab.category": "Kategori",
  "admin.faqTab.sortOrder": "Sıralama",
  "admin.faqTab.status": "Durum",
  "admin.faqTab.question": "Soru",
  "admin.faqTab.answer": "Cevap",
  "admin.faqTab.questionRequired": "Soru ve cevap zorunludur.",
  "admin.faqTab.saveFailed": "Kaydetme başarısız",
  "admin.faqTab.deleteFailed": "Silme başarısız",
  "admin.faqTab.deleteConfirm": "Bu SSS öğesini kalıcı olarak silmek istediğinize emin misiniz?",
  "admin.faqTab.items_one": "öğe",
  "admin.faqTab.items_other": "öğe",
  "admin.faqTab.add": "Ekle",
  "admin.faqTab.loading": "SSS öğeleri yükleniyor...",
  "admin.faqTab.noMatch": "Filtrelere uyan SSS öğesi yok.",
  "admin.faqTab.noCategoryItems": "Bu kategoride henüz SSS öğesi yok.",
  "admin.faqTab.addOne": "Bir tane ekleyin",
  "admin.faqTab.activate": "Aktifleştir",
  "admin.faqTab.deactivate": "Pasifleştir",
  "admin.faqTab.edit": "Düzenle",
  "admin.faqTab.delete": "Sil",
  "admin.faqTab.cat.0": "Şirket Kuruluşu",
  "admin.faqTab.cat.1": "Vize & Göçmenlik",
  "admin.faqTab.cat.2": "İş Geliştirme",
  "admin.faqTab.cat.3": "Platform & Ortaklık",
  "admin.faqTab.cat.4": "LegalTech & Yapay Zeka",
  "admin.faqTab.cat.5": "Uyumluluk & Veri Gizliliği",

  "admin.partnersTab.searchPlaceholder": "Partner ara...",
  "admin.partnersTab.allCountries": "Tüm Ülkeler",
  "admin.partnersTab.allPracticeAreas": "Tüm Uzmanlık Alanları",
  "admin.partnersTab.clear": "Temizle",
  "admin.partnersTab.newPartner": "Yeni Partner",
  "admin.partnersTab.editPartner": "Partneri Düzenle",
  "admin.partnersTab.createPartner": "Partner Oluştur",
  "admin.partnersTab.cancel": "İptal",
  "admin.partnersTab.saveChanges": "Değişiklikleri Kaydet",
  "admin.partnersTab.name": "Firma Adı",
  "admin.partnersTab.rating": "Puan",
  "admin.partnersTab.country": "Ülke",
  "admin.partnersTab.city": "Şehir",
  "admin.partnersTab.flag": "Bayrak Emoji",
  "admin.partnersTab.website": "Web Sitesi",
  "admin.partnersTab.status": "Durum",
  "admin.partnersTab.practiceAreas": "Uzmanlık Alanları",
  "admin.partnersTab.description": "Açıklama",
  "admin.partnersTab.requiredFields": "Firma adı, ülke ve şehir zorunludur.",
  "admin.partnersTab.saveFailed": "Kaydetme başarısız",
  "admin.partnersTab.deleteFailed": "Silme başarısız",
  "admin.partnersTab.deleteConfirm": "Bu partneri kalıcı olarak silmek istediğinize emin misiniz?",
  "admin.partnersTab.loading": "Partnerler yükleniyor...",
  "admin.partnersTab.noMatch": "Filtrelere uyan partner yok.",
  "admin.partnersTab.noPartners": "Henüz partner yok.",
  "admin.partnersTab.edit": "Düzenle",
  "admin.partnersTab.delete": "Sil",
  "admin.partnersTab.active": "Aktif",
  "admin.partnersTab.inactive": "Pasif",
  "admin.partnersTab.firm": "Firma",
  "admin.partnersTab.location": "Konum",
  "admin.partnersTab.actions": "İşlemler",

  "admin.testimonialsTab.searchPlaceholder": "Referanslarda ara...",
  "admin.testimonialsTab.allStatuses": "Tüm Durumlar",
  "admin.testimonialsTab.active": "Aktif",
  "admin.testimonialsTab.inactive": "Pasif",
  "admin.testimonialsTab.clear": "Temizle",
  "admin.testimonialsTab.newTestimonial": "Yeni Referans",
  "admin.testimonialsTab.editTestimonial": "Referans Düzenle",
  "admin.testimonialsTab.saveChanges": "Değişiklikleri Kaydet",
  "admin.testimonialsTab.create": "Referans Oluştur",
  "admin.testimonialsTab.cancel": "İptal",
  "admin.testimonialsTab.quote": "Alıntı",
  "admin.testimonialsTab.quoteRequired": "Alıntı *",
  "admin.testimonialsTab.name": "İsim",
  "admin.testimonialsTab.nameRequired": "İsim *",
  "admin.testimonialsTab.role": "Unvan",
  "admin.testimonialsTab.company": "Şirket",
  "admin.testimonialsTab.sortOrder": "Sıralama",
  "admin.testimonialsTab.status": "Durum",
  "admin.testimonialsTab.avatarUrl": "Avatar URL",
  "admin.testimonialsTab.preview": "Önizleme",
  "admin.testimonialsTab.order": "Sıra",
  "admin.testimonialsTab.actions": "İşlem",
  "admin.testimonialsTab.edit": "Düzenle",
  "admin.testimonialsTab.delete": "Sil",
  "admin.testimonialsTab.requiredFields": "Alıntı ve isim zorunludur.",
  "admin.testimonialsTab.saveFailed": "Kaydetme başarısız",
  "admin.testimonialsTab.deleteFailed": "Silme başarısız",
  "admin.testimonialsTab.loadFailed": "Referanslar yüklenemedi",
  "admin.testimonialsTab.deleteConfirm": "Bu referans kalıcı olarak silinsin mi?",
  "admin.testimonialsTab.loading": "Referanslar yükleniyor...",
  "admin.testimonialsTab.noItems": "Henüz referans yok.",
  "admin.testimonialsTab.retry": "Tekrar Dene",
  "admin.testimonialsTab.saving": "Kaydediliyor...",
  "admin.testimonialsTab.unknownError": "Bilinmeyen hata",

  "admin.pageBuilder.title": "Sayfa Yapılandırıcı",
  "admin.pageBuilder.builderOn": "Builder Açık",
  "admin.pageBuilder.builderOff": "Builder Kapalı",
  "admin.pageBuilder.published": "Yayında",
  "admin.pageBuilder.draft": "Taslak",
  "admin.pageBuilder.save": "Kaydet",
  "admin.pageBuilder.saving": "Kaydediliyor...",
  "admin.pageBuilder.saved": "Kaydedildi!",
  "admin.pageBuilder.pages": "Sayfalar",
  "admin.pageBuilder.sectionOrder": "Section Sıralaması",
  "admin.pageBuilder.dragHint": "Sürükle-bırak ile sıralayın",
  "admin.pageBuilder.selectPage": "Sol taraftan bir sayfa seçin",
  "admin.pageBuilder.noPages": "Henüz sayfa şeması yok",
  "admin.pageBuilder.noPagesDesc": "Veritabanında hiç page_schema kaydı bulunamadı. Önce sayfa şemalarını oluşturun.",
  "admin.pageBuilder.jsonPreview": "JSON Önizleme",
  "admin.pageBuilder.variant": "Varyant",
  "admin.pageBuilder.loading": "Sayfa şemaları yükleniyor...",

  "admin.jurisdictions.loadFailed": "Yükleme başarısız",
  "admin.jurisdictions.loading": "Bölgeler yükleniyor...",
  "admin.jurisdictions.retry": "Tekrar Dene",
  "admin.jurisdictions.search": "Bölgelerde ara...",
  "admin.jurisdictions.count": "bölge",
  "admin.jurisdictions.add": "Bölge Ekle",
  "admin.jurisdictions.popular": "Popüler",
  "admin.jurisdictions.inactive": "Pasif",
  "admin.jurisdictions.edit": "Düzenle",
  "admin.jurisdictions.makePopular": "Popüler Yap",
  "admin.jurisdictions.removePopular": "Popülerlikten Çıkar",
  "admin.jurisdictions.activate": "Aktifleştir",
  "admin.jurisdictions.deactivate": "Pasifleştir",
  "admin.jurisdictions.saveFailed": "Kaydetme başarısız",
  "admin.jurisdictions.deleteFailed": "Silme başarısız",
  "admin.jurisdictions.unknownError": "Bilinmeyen hata",
  "admin.jurisdictions.deleteConfirm": "\"{country}\" silinsin mi?",
  "admin.jurisdictions.noResults": "Bölge bulunamadı.",
  "admin.jurisdictions.modalEdit": "Bölgeyi Düzenle",
  "admin.jurisdictions.modalCreate": "Bölge Ekle",
  "admin.jurisdictions.country": "Ülke *",
  "admin.jurisdictions.entity": "Şirket Türü *",
  "admin.jurisdictions.price": "Fiyat *",
  "admin.jurisdictions.flagIcon": "Bayrak İkonu (Remix Icon)",
  "admin.jurisdictions.image": "Bölge Görseli",
  "admin.jurisdictions.sortOrder": "Sıralama",
  "admin.jurisdictions.popularCb": "Popüler",
  "admin.jurisdictions.activeCb": "Aktif",
  "admin.jurisdictions.cancel": "İptal",
  "admin.jurisdictions.saving": "Kaydediliyor...",
  "admin.jurisdictions.update": "Güncelle",
  "admin.jurisdictions.create": "Oluştur",
  "admin.jurisdictions.countryPh": "örn: Almanya",
  "admin.jurisdictions.entityPh": "örn: GmbH / UG",
  "admin.jurisdictions.pricePh": "örn: €1.200'den başlayan",

  "admin.siteSettings.loadFailed": "Ayarlar yüklenemedi",
  "admin.siteSettings.loading": "Ayarlar yükleniyor...",
  "admin.siteSettings.retry": "Tekrar Dene",
  "admin.siteSettings.saved": "Kaydedildi!",
  "admin.siteSettings.saveFailed": "Kaydetme başarısız",
  "admin.siteSettings.unknownError": "Bilinmeyen hata",
  "admin.siteSettings.openLink": "Bağlantıyı Aç",
  "admin.siteSettings.saving": "Kaydediliyor...",
  "admin.siteSettings.save": "Kaydet",
  "admin.siteSettings.settingCount": "ayar",
  "admin.siteSettings.urlPlaceholder": "https://...",
  "admin.siteSettings.group.general": "Genel",
  "admin.siteSettings.group.branding": "Marka",
  "admin.siteSettings.group.seo": "SEO & Meta",
  "admin.siteSettings.group.social": "Sosyal Medya",
  "admin.siteSettings.group.contact": "İletişim",
  "admin.siteSettings.group.analytics": "Analitik",
};